import React from 'react'
import 'whatwg-fetch'
import moment from "moment"
import Calendar from 'react-calendar'
import './Calendar.css';

import {
  useToast,
  useColorMode,
  useDisclosure,
  SimpleGrid,
  Flex,
  Box,
  Button,
  IconButton,
  Input,
  Select,
  Text,
  Image,
  Divider,
  Textarea,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Stack,
  Icon,
  Heading,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  //PopoverArrow,
  PopoverCloseButton,
  Spinner,
  Switch,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  NumberInput,
} from '@chakra-ui/core'

//import { Sticky, StickyProvider } from 'react-stickup';

//const price_night = 63;
//const price_clean = 43;
//const price_clean_dog = 58;
//const tax_season = 3.50;
//const tax_outside = 1.75;

/**
 * TODO:
 * - Set end -> automatically find start and set end for that
 * - Fetch bookings after a while?
 * - arrival/department selectable
 * - per-apartment
 * - don't delete end when setting new start in this version
 */

export default function MainComponent() {
  moment.locale('de'); //try setting locale gloablly, doesn't work
  const [bookings, setBookings] = React.useState([]);
  const [assigned, setAssigned] = React.useState([]);
  const [preise, setPrices] = React.useState({});
  const [appointments, setAppointments] = React.useState([]);
  const [toastMessage, setToastMessage] = React.useState();
  const defaultAlert = {type: "info", title: "Apartment & Zeitraum wählen", body: "Wählen Sie ein Apartment und setzen Sie An- und Abreisetag für ihre Anfrage"};
  const [alertMessage, setAlertMessage] = React.useState(defaultAlert);
  const [calendarSelected, setCalendarSelected] = React.useState();
  const [selected, setSelected] = React.useState();
  const [selectedAction, setSelectedAction] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const formatter = new Intl.DateTimeFormat('de', {weekday: 'short', day: '2-digit', month: 'short', year: '2-digit'});
  const toast = useToast();


  const [customerName, setCustomerName] = React.useState("");
  const [customerMessage, setCustomerMessage] = React.useState("");
  const [customerEmail, setCustomerEmail] = React.useState("");
  const [customerPhone, setCustomerPhone] = React.useState("");
  const [customerCount, setCustomerCount] = React.useState(1);
  const [customerDog, setCustomerDog] = React.useState(false);

  const [selectedRoom, setSelectedRoom] = React.useState("/norder");
  const [calculatedPrice, setCalculatedPrice] = React.useState(0);
  const [calculatedTax, setCalculatedTax] = React.useState(0);
  //const bookingCalendar = React.createRef();

  const {colorMode, toggleColorMode} = useColorMode();

  //console.log(localStorage.getItem("iosPwaPrompt"));

  // first load
  React.useEffect(() => {
    // load user info from localStorage
    const userData = localStorage.getItem("MelnstichWebAppUser");
    if (userData) {
      const user = JSON.parse(userData);
      setCustomerName(user.name);
      setCustomerEmail(user.email);
      setCustomerPhone(user.phone);
    }
    loadPrices();
    // if theres a GET parameter, set room
    const urlParams = new URLSearchParams(window.location.search);
    const room = urlParams.get('room');
    // get booked days from server
    if (room) {
      // TODO: why does the dropdown not update on set?
      setTimeout(() => {
        document.getElementsByName("room")[0].value = "/" + room;
      }, 100);
      setSelectedRoom("/" + room);
    } else {
      loadBooked();
    }
  }, [])

  // reload when room changed
  React.useEffect(() => {
    // get booked days from server
    loadBooked();
  }, [selectedRoom])

  // update assigned days when appointments change
  React.useEffect(() => {
    const arr = [];
    appointments.forEach(appt => {
      arr.push(appt.startDate.toDate());
      if (appt.endDate) {
        const nuDate = appt.startDate.clone();
        while (nuDate.isBefore(appt.endDate)) {
          nuDate.add(1, "day");
          arr.push(nuDate.toDate());
        }
      }
    });
    setAssigned(arr);
  }, [appointments])

  // calculate prices
  React.useEffect(() => {
    if (appointments.length > 0) {
      if (appointments[0].endDate) {
        const nightsSpent = appointments[0].endDate.diff(appointments[0].startDate, "days");
        var taxPrice = preise.kurtaxe_nebensaison;
        const startMonth = appointments[0].startDate.month();
        const endMonth = appointments[0].endDate.month();
        if ((startMonth >= 4 && startMonth <= 9) || (endMonth >= 4 && endMonth <= 9)) {
          taxPrice = preise.kurtaxe_saison;
        }
        setCalculatedTax(nightsSpent * taxPrice);
        setCalculatedPrice((nightsSpent * preise.nacht_saison) + (customerDog ? preise.endreinigung+preise.hundezuschlag : preise.endreinigung));
      } else {
        setCalculatedTax(0);
        setCalculatedPrice(0);
      }
    } else {
      setCalculatedTax(0);
      setCalculatedPrice(0);
    }
  }, [appointments, customerDog, preise.endreinigung, preise.hundezuschlag, preise.kurtaxe_nebensaison, preise.kurtaxe_saison, preise.nacht_saison])

  // show toast when toast message changes
  React.useEffect(() => {
    if (toastMessage) {
      var {title, body, type} = toastMessage;
      if (!type) {
        type = "error";
      }
      toast({
        title,
        description: body,
        status: type,
        duration: 6000,
        position: "bottom",
        isClosable: true
      });
    }
  }, [toastMessage, toast]);

  // loads booked days from server and populates bookings
  const loadPrices = function () {
    const myUrl = 'https://cdn.melnstich5.de/preise.json';
    //setLoading(true);
    fetch(myUrl).then(function (response) {
      return response.json()
    }).then(function (json) {
      setPrices(json.preise);
    }).catch(function (ex) {
      setAlertMessage({type: "error", title: "Serverfehler", body: "Die Preise können nicht geladen werden, versuchen sie es später noch einmal"});
      console.log('parsing failed', ex)
    }).finally(function () {
      //setLoading(false);
    });
  }

  const loadBooked = function () {
    const myUrl = '/bookings' + selectedRoom;
    setLoading(true);
    fetch(myUrl).then(function (response) {
      return response.json()
    }).then(function (json) {
      const bookArray = [];
      json.forEach(bl => {
        const myDate = new Date(bl[0], bl[1], bl[2]);
        if (bl[3]) {
          myDate.changeType = bl[3];
        }
        bookArray.push(myDate);
      });
      setBookings(bookArray);
      if (appointments.length === 0) {
        setAlertMessage(defaultAlert);
      }
    }).catch(function (ex) {
      setAlertMessage({type: "error", title: "Serverfehler", body: "Die belegten Termine können nicht geladen werden, versuchen sie es später noch einmal"});
      console.log('parsing failed', ex)
    }).finally(function () {
      setLoading(false);
    });
  }

  //called when a day is selected in the calendar
  const dayClick = function (date) {
    const data = {
      date: moment(date),
      isBookedDay: bookings.find(elem => sameDayNoChange(elem, date)) !== undefined,
      isAssignedDay: assigned.find(elem => sameDay(elem, date)) !== undefined,
    }
    if (selectedAction === 1) {
      setDay(null, data);
      setSelectedAction(0);
    } else if (selectedAction === 2) {
      setEnd(null, data);
      setSelectedAction(0);
    } else {
      setCalendarSelected(date);
      setSelected(data);
    }
  }

  // sets start day, called on add appointment button or directly by calendar click
  const setDay = function (event, par) {
    var myInfo = par ? par : selected;
    if (!myInfo) {
      setToastMessage({type: "info", title: "Tag wählen", body: "Bitte wählen Sie einen Tag aus"})
      setSelectedAction(1);
    }
    else if (myInfo.date.isBefore(moment())) {
      setToastMessage({type: "error", title: "Vergangenheit", body: "Die Buchung kann nicht in der Vergangeheit stattfinden"})
    }
    else if (myInfo.isBookedDay) {
      setToastMessage({type: "error", title: "Tag Belegt", body: "Der Termin ist leider schon belegt"})
    }
    else {
      myInfo.isAssignedDay = true;
      // setting only one appointment in this calendar, could update start date if exists
      // -> need to do in between checks etc. then
      /*if(appointments.length>0){
        const myAppointment = appointments[0];
        myAppointment.startDate = myInfo.date.clone();
        myAppointment.start = formatter.format(myInfo.date);
        setAppointments([myAppointment]);
      }else{*/
      setAppointments([{
        startDate: myInfo.date.clone(),
        start: formatter.format(myInfo.date),
        isWarning: true
      }]);
      //}
      setCalendarSelected([]);
      setSelected();
    }
  }

  // sets end day, called on set end button or directly by calendar click
  const setEnd = function (event, par) {
    const myInfo = par ? par : selected;
    // TODO: find appointment with start just before date
    const index = appointments.length - 1;
    if (!myInfo) { // no date passed
      if (appointments.length === 0) {
        setToastMessage({type: "error", title: "Kein Termin", body: "Bitte fügen Sie einen Termin hinzu"})
      } else { // prepare next click selection
        setToastMessage({type: "info", title: "Tag wählen", body: "Bitte wählen Sie einen Tag aus"})
        setSelectedAction(2);
      }
    }
    else if (myInfo.date.isBefore(moment())) {
      setToastMessage({type: "error", title: "Vergangenheit", body: "Der Termin kann nicht in der Vergangeheit stattfinden"})
    }
    else if (myInfo.isBookedDay) {
      setToastMessage({type: "error", title: "Tag Belegt", body: "Der Termin ist leider schon belegt"})
    }
    else if (appointments.length > 0) {
      if (myInfo.date.isSame(appointments[index].startDate)) {
        setToastMessage({type: "error", title: "Gleicher Tag", body: "Der Mindestzeitraum für eine Buchung ist 5 Tage"})
      } else if (myInfo.date.isBefore(appointments[index].startDate)) {
        setToastMessage({type: "error", title: "Abreise vor Anreise", body: "Die Abreise kann nicht vor der Anreise sein"})
      } else if (myInfo.date.isBefore(appointments[index].startDate.clone().add(5, "day"))) {
        setToastMessage({type: "error", title: "Zu Kurzer Zeitraum", body: "Der Buchungszeitraum muss mindestens 5 Übernachtungen betragen"})
      } else {
        // check in between days
        const nuDate = appointments[index].startDate.clone();
        while (nuDate.isBefore(myInfo.date)) {
          nuDate.add(1, "day");
          if (bookings.find(elem => sameDayNoChange(elem, nuDate.toDate())) !== undefined) {
            setToastMessage({type: "error", title: "Gebuchte Tage", body: "In diesem Zeitraum befinden sich ausgebuchte Tage"})
            return;
          }
        }

        myInfo.isAssignedDay = true;
        appointments[index].endDate = myInfo.date.clone();
        appointments[index].end = formatter.format(myInfo.date);
        appointments[index].isWarning = false;
        setAppointments(appointments.concat([]));
        setCalendarSelected([]);
        setSelected();
      }
    } else {
      setToastMessage({type: "error", title: "Keine Anreise", body: "Bitte fügen Sie eine Anreise hinzu"})
    }
  }

  // deletes the appointment at idx
  const deleteAppointment = function (idx) {
    //appointments.splice(idx,1);
    //React.setState({appointments})
    const newAppointments = appointments.filter((item, idex) => idex !== idx);
    setAppointments(newAppointments);
    if (newAppointments.length === 0) {
      setAlertMessage(defaultAlert);
      setCustomerDog(false);
    }
  }

  const handleCountChange = function (count) {
    if (count < 1 || count > 4) return;
    setCustomerCount(count);
  }

  // update states based on input changes
  const handleInputChange = function (event) {
    const target = event.target;
    const name = target.name;
    switch (name) {
      case "name": setCustomerName(target.value);
        break;
      case "message": setCustomerMessage(target.value);
        break;
      case "email": setCustomerEmail(target.value);
        break;
      case "phone": setCustomerPhone(target.value);
        break;
      case "dog": setCustomerDog(!customerDog);
        break;
      case "room": setSelectedRoom(target.value);
        break;
      default:
        break;
    }
  }

  // send button pressed -> check and send
  const handleSubmit = async function (event) {
    const user = {};
    user.name = customerName;
    user.email = customerEmail;
    user.phone = customerPhone;
    localStorage.setItem("MelnstichWebAppUser", JSON.stringify(user));

    if (!customerName) {
      setToastMessage({type: "error", title: "Bitte Namen angeben", body: "Bitte geben Sie Ihren Namen an"})
    } else if (!customerEmail && !customerPhone) {
      setToastMessage({type: "error", title: "Bitte Kontakt angeben", body: "Bitte geben sie eine Kontaktmöglichkeit an"})
    } else if (!customerMessage && appointments.length === 0) {
      setToastMessage({type: "error", title: "Kein Inhalt", body: "Bitte geben sie einen Terminvorschlag oder eine Nachricht an"})
    } else if (appointments.length > 0 && appointments[0].isWarning) {
      setToastMessage({type: "error", title: "Kein Abreisetag", body: "Bitte geben sie einen Abreisetag an"})
    } else {
      const dates = [];
      appointments.forEach(appointment => {
        const s = appointment.startDate;
        const e = appointment.endDate;
        const appt = {
          startDate: [s.year(), s.month(), s.date()]
        };
        if (e) {
          appt.endDate = [e.year(), e.month(), e.date()]
        }
        dates.push(appt);
      });
      try {
        const response = await fetch('/message', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: customerName,
            message: customerMessage,
            email: customerEmail,
            phone: customerPhone,
            count: customerCount,
            dog: customerDog,
            room: selectedRoom,
            dates: dates
          })
        });
        let payload = null;
        try {
          payload = await response.json();
        } catch (jsonError) {
          // ignore JSON parse errors; payload stays null
        }
        if (!response.ok) {
          const errorMessage = payload && payload.message ? payload.message : "Ein Serverfehler ist beim Senden aufgetreten, versuchen Sie es später noch einmal.";
          setToastMessage({type: "error", title: "Fehler", body: errorMessage});
          return;
        }
        if (payload && payload.status === "OK") {
          setToastMessage({type: "success", title: "Anfrage gesendet", body: "Wir melden uns baldestmöglich bei Ihnen"});
          setAlertMessage({type: "success", title: "Wir bearbeiten Ihre Anfrage", body: "Wir hoffen Sie bald bei uns begrüßen zu dürfen"});
          resetInput();
        } else {
          setToastMessage({type: "error", title: "Fehler", body: (payload && payload.message) ? payload.message : "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut."});
        }
      } catch (ex) {
        setToastMessage({type: "error", title: "Fehler", body: "Ein Fehler ist beim Senden aufgetreten, sind Sie mit dem Internet verbunden?"});
      }
    }
    // only needed for onSubmit from forms to prevent redirection
    //event.preventDefault();
  }

  // reset appointments and message field
  const resetInput = function () {
    setCustomerMessage("");
    setAppointments([]);
    setCustomerDog(false);
  }

  // gets the class name for a day box (set background based on bookings)
  const dayClassName = function (data) {
    if (data.view !== 'month') return "";
    if (assigned.find(elem => sameDay(elem, data.date)) !== undefined) {
      return "assigned-day";
    } else if (bookings.find(elem => sameDay(elem, data.date)) !== undefined) {
      return "booked-day";
    } else {
      return "";
    }
  }

  // check if JS Date is booked
  const isBookedDay = function (data) {
    if (data.view !== 'month') return false;
    return bookings.find(elem => sameDayNoChange(elem, data.date)) !== undefined;
  }

  // label for the navigation in the calendar, shows loading state with spinner
  const navLoadingLabel = function ({date, label, locale, view}) {
    return loading ? <Spinner /> : label;
  }

  const infoDisclosure = useDisclosure();
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center" >
      <Flex
        flexDirection="column"
        alignItems="stretch"
        justifyContent="center"
        shadow="sm"
        maxWidth={500}
        //backgroundColor="#fff"
        m="2px"
        p="5px"
      >
        <Box mb="3px" borderRadius="1px" display="flex" justifyContent="center" alignItems="center">
          {/*<Text onClick={infoDisclosure.onOpen} fontSize="2xl" fontWeight="bold" textAlign="center">
            Melnstich 5
          </Text>*/}
          <Image width="70%" onClick={infoDisclosure.onOpen} src={colorMode === 'dark' ? "https://cdn.melnstich5.de/Appartementvermietung-Hansen-Logo-White.png" : "https://cdn.melnstich5.de/Appartementvermietung-Hansen-Logo-Black.png"} />
        </Box>
        <Box>
          <Text fontSize="xl" fontWeight="bold" textAlign="center">
            Buchungskalender
          </Text>
        </Box>
        <Divider borderColor="blackAlpha.500" />
        <Box>
          <Select name="room" value={selectedRoom} onChange={handleInputChange} icon="chevron-down">
            {/*<option value="">Alle Apartments</option>*/}
            <option value="/norder">Norder Apartment</option>
            <option value="/wester">Wester Apartment</option>
          </Select>
          <Calendar
            navigationLabel={navLoadingLabel}
            minDate={new Date()}
            value={calendarSelected}
            onChange={dayClick}
            tileDisabled={isBookedDay}
            tileClassName={dayClassName}
          />
        </Box>
        <SimpleGrid columns={2} spacingX={1} spacingY={1}>
          <Button leftIcon="add" onClick={setDay}>Anreise</Button>
          <Button leftIcon="calendar" onClick={setEnd}>Abreise</Button>
        </SimpleGrid>
        <Divider borderColor="blackAlpha.500" />
        <Stack>
          {appointments.length === 0 ?
            <Alert status={alertMessage.type} display="flex" justifyContent="center" flexDirection="column">
              <AlertIcon width="30px" height="30px" mb="2" />
              <AlertTitle mr={1} mb={1}>{alertMessage.title}</AlertTitle>
              <AlertDescription textAlign="center">
                {alertMessage.body}
              </AlertDescription>
            </Alert>
            :
            <Heading textAlign="center" size="md">
              Buchungszeitraum
        </Heading>
          }
          {appointments.map((appointment, idx) =>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              key={idx}
            >
              {appointment.isWarning ?
                <Popover>
                  <PopoverTrigger>
                    <Icon name="warning-2" color="yellow.500" />
                  </PopoverTrigger>
                  <PopoverContent zIndex={4}>
                    <PopoverCloseButton />
                    <PopoverHeader fontWeight="bold">Kein Abreisetag</PopoverHeader>
                    <PopoverBody>Bitte fügen sie einen Abreisetag hinzu.</PopoverBody>
                  </PopoverContent>
                </Popover>
                :
                <Icon name="check-circle" color="green.500" />
              }
              <Text>{appointment.start} {appointment.end ? ' - ' + appointment.end : " - ???"}</Text>
              <IconButton aria-label="icon" icon="delete" color="red.500" onClick={() => deleteAppointment(idx)} />
            </Box>
          )}
        </Stack>
        {(appointments.length !== 0 && appointments[0].endDate) ?
          <div>
            <Divider borderColor="blackAlpha.500" />
            <SimpleGrid columns={2} spacingX={1} spacingY={2}>
              <Text>Anzahl Personen:</Text>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                <NumberInput name="count" value={customerCount} onChange={handleCountChange} step={1} width="20" />
              </Box>
              <Text>Mit Hund:</Text>
              <Box display="flex" justifyContent="flex-end" alignItems="center">
                <Switch name="dog" mr="5" value={customerDog} onChange={handleInputChange} size="lg" />
              </Box>
            </SimpleGrid>
          </div>
          : <div />
        }
        {calculatedPrice > 0 ?
          <div>
            <Divider borderColor="blackAlpha.500" />
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Text>Geschätzter Preis: <b>{calculatedPrice}€</b></Text>
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Text textAlign="right" fontSize="xs">zzgl. geschätzt {parseFloat(Math.round(calculatedTax * 100) / 100).toFixed(2)}€ Kurabgaben pro Erwachsener</Text>
            </Box>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <Text textAlign="right" fontSize="xs">(Unverbindliche Richtwerte)</Text>
            </Box>
          </div>
          : <div />}
        <Divider borderColor="blackAlpha.500" />
        <SimpleGrid columns={2} spacingX={1} spacingY={1}>
          <Text display="flex" alignItems="center">
            Ihr Name:
          </Text>
          <Input name="name" value={customerName} onChange={handleInputChange} placeholder="Max Mustermann" />
          <Text>Ihre Nachricht:</Text>
          <Textarea name="message" value={customerMessage} onChange={handleInputChange} placeholder="Ich möchte eine Ferienwohnung buchen." />
          <Text display="flex" alignItems="center">
            eMail:
          </Text>
          <Input name="email" value={customerEmail} onChange={handleInputChange} placeholder="max.mustermann@email.de" />
          <Text display="flex" alignItems="center">
            Telefonnummer:
          </Text>
          <Input name="phone" value={customerPhone} onChange={handleInputChange} placeholder="+49 160 1234567" />
        </SimpleGrid>
        <Divider borderColor="blackAlpha.500" />
        <Button onClick={handleSubmit} leftIcon="email">Anfrage Senden</Button>
        <Text fontSize="xs" textAlign="center">
          Ihre Anfrage ist nicht verbindlich. Alle eingegebenen Daten werden ausschliesslich dazu verwendet Ihre
          Anfrage zu beantworten. <a href="http://melnstich5.de/datenschutz">(Datenschutzerklärung hier)</a>
        </Text>
        <Modal isOpen={infoDisclosure.isOpen} onClose={infoDisclosure.onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Melnstich 5 Booking</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text>WebApp © 2020 by Normen Hansen</Text>
            </ModalBody>
            <ModalFooter>
              <Button size="xs" mr={2} onClick={loadBooked}>
                Kalender Neu Laden
              </Button>
              <Button size="xs" mr={2} onClick={resetInput}>
                Eingaben Löschen
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>
    </Flex>
  );
}

function sameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}

function sameDayNoChange(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate() && d1.changeType === undefined;
}
